import { CNPJ_LENGTH_WITHOUT_MASK, CPF_CNPJ_MASK, CPF_LENGTH_WITHOUT_MASK } from 'app-constants'

export function isCpf(document) {
  return /^\d{3}.\d{3}.\d{3}-\d{2}$/.test(document)
}

export function formatCpf(document) {
  return document
    .replace(/([a-z0-9]{3})([a-z0-9])/, '$1.$2')
    .replace(/([a-z0-9]{3})([a-z0-9])/, '$1.$2')
    .replace(/([a-z0-9]{3})([a-z0-9]{1,2})$/, '$1-$2')
}

export function formatCnpj(document) {
  return document
    .replace(/^([a-z0-9]{2})([a-z0-9])/, '$1.$2')
    .replace(/^([a-z0-9]{2})\.([a-z0-9]{3})([a-z0-9])/, '$1.$2.$3')
    .replace(/\.([a-z0-9]{3})([a-z0-9])/, '.$1/$2')
    .replace(/([a-z0-9]{4})([a-z0-9])/, '$1-$2')
}

export function isValidDocumentLength(document) {
  const documentWithOnlyLettersAndNumbers = document.replace(CPF_CNPJ_MASK, '')
  const hasCpfLength = documentWithOnlyLettersAndNumbers.length === CPF_LENGTH_WITHOUT_MASK
  const hasCnpjLength = documentWithOnlyLettersAndNumbers.length === CNPJ_LENGTH_WITHOUT_MASK

  return hasCpfLength || hasCnpjLength
}
